import React from "react";
import "./../../../../assets/css/general/blog/BlogCard/BlogCard.css";

const BlogCard = ({ post }) => {
  return (
    <article className="blog-card">
      <div className="blog-card-image-wrapper">
        <img src={post.image} alt={post.title} className="blog-card-image" />
        <span className="blog-card-category">{post.category}</span>
        <button
          type="button"
          className="blog-card-bookmark"
          aria-label="Bookmark article"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
          </svg>
        </button>
      </div>

      <div className="blog-card-content">
        <h3 className="blog-card-title">{post.title}</h3>
        <p className="blog-card-description">{post.description}</p>

        <div className="blog-card-meta">
          <div className="blog-card-author-info">
            <span className="blog-card-author">{post.author}</span>
            <span className="blog-card-divider">•</span>
            <span className="blog-card-time">{post.readTime}</span>
          </div>
          <span className="blog-card-date">{post.date}</span>
        </div>

        <a href="#" className="blog-card-link">
          Read More →
        </a>
      </div>
    </article>
  );
};

export default BlogCard;
